import { useApiQuery } from '@locus-taxy/encore-ui-network';
import { useToast } from '@locus-taxy/encore-ui-toolkit';
import type { ApiError } from '@locus-taxy/encore-ui-network';

export interface ClientMetadataResponse {
  data: {
    organizationId: string;
    loginFlow: 'DEFAULT' | string;
  };
  success: boolean;
  message?: string | null;
}

const CLIENT_METADATA_ENDPOINT_KEY = 'client.metadata';

export function useClientMetadata(
  clientId: string | null,
  options?: { enabled?: boolean }
) {
  const { showApiError } = useToast();
  return useApiQuery<ClientMetadataResponse>({
    key: [CLIENT_METADATA_ENDPOINT_KEY, clientId ?? ''],
    endpointKey: CLIENT_METADATA_ENDPOINT_KEY,
    params: { clientId: (clientId ?? '') as string },
    config: {
      requireAuth: false,
      enabled:
        typeof options?.enabled === 'boolean'
          ? options.enabled
          : Boolean(clientId),
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      onError: (error: ApiError) => {
        showApiError(error);
      },
    },
  });
}
